export default {
  dashboard: () => import("/vercel/path0/v3/layouts/dashboard.vue").then(m => m.default || m),
  website: () => import("/vercel/path0/v3/layouts/website.vue").then(m => m.default || m)
}